import React from 'react';
import { Facebook, Twitter, Instagram, Youtube, Linkedin } from 'lucide-react';

const Footer = () => {
  const footerLinks = {
    Trading: ['Forex', 'Stocks'],
    Company: ['About Us', 'Contact Us', 'Terms & Conditions', 'Privacy Policy'],
    Support: ['Help Center', 'FAQ', 'Getting Started Guide'],
    Platform: ['Web Platform', 'Mobile App'],
  };

  const socialLinks = [
    { icon: Facebook, href: '#facebook' },
    { icon: Twitter, href: '#twitter' },
    { icon: Instagram, href: '#instagram' },
    { icon: Youtube, href: '#youtube' },
    { icon: Linkedin, href: '#linkedin' },
  ];

  return (
    <footer className="relative bg-black border-t border-white/5">
      <div className="max-w-7xl mx-auto px-8 py-20">
        {/* Main footer content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 mb-16 animate-fade-in-up">
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-white font-bold mb-6 text-lg tracking-wide">{category}</h3>
              <ul className="space-y-4">
                {links.map((link) => {
                  const linkMap = {
                    // Trading
                    'Forex': '/trading/forex',
                    'Stocks': '/trading/stocks',
                    'Indices': '/trading',
                    'Commodities': '/trading',
                    'Crypto': '/trading',
                    // Company
                    'About Us': '/about',
                    'Contact Us': '/contact',
                    'Terms & Conditions': '/terms-conditions',
                    'Privacy Policy': '/privacy-policy',
                    // Support
                    'Help Center': '/help',
                    'FAQ': '/help',
                    'Getting Started Guide': '/help',
                    'Deposit & Withdrawal Guide': '/help',
                    'Safety & Security': '/help',
                    'Trading Policies': '/help',
                    // Platform
                    'Web Platform': '/trading',
                    'Mobile App': '/download',
                  };
                  const href = linkMap[link] || '#';
                  
                  return (
                    <li key={link}>
                      <a
                        href={href}
                        className="text-gray-400 hover:gradient-gold-text transition-all duration-300 text-sm hover:translate-x-2 inline-block"
                      >
                        {link}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom section */}
        <div className="space-y-8 animate-fade-in-up animate-delay-400">
          {/* Logo */}
          <div className="flex items-center justify-center">
           <img
  src="/images/Stoxchain Logo-01.png"
  alt="SpreadexAsia"
  className="
    h-16 scale-175              /* 📱 Mobile: bigger height + scale */
    sm:h-16 sm:scale-200        /* Slightly bigger on small screens */
    md:h-16 md:scale-225        /* Tablet */
    lg:h-16 lg:scale-250        /* Desktop */
    origin-center
    transition-all duration-300
  "
/>



</div>


          {/* Company Description */}
          <div className="text-center text-gray-400 text-base max-w-4xl mx-auto leading-relaxed">
            <p>
              With 7 years of experience in automated Forex and Stock trading systems, we focus on providing tools that support informed and responsible decision-making. Trading always involves risk, and results can vary, but our technology is built to help users understand market movements, manage exposure, and trade with greater clarity and confidence.
            </p>
          </div>

          {/* Copyright and legal */}
          <div className="text-center text-gray-500 text-sm space-y-4 pt-8">
            <p className="font-medium">
              © 2018–2026 SpreadexAsia. All Rights Reserved
            </p>
            <p className="max-w-4xl mx-auto leading-relaxed">
              Risk Warning: Trading in financial instruments carries a high level of risk and may not be suitable for all investors.
              Before trading, please ensure you fully understand the risks involved and seek independent advice if necessary.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
